import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-launch-round-of-questions',
  templateUrl: './launch-round-of-questions.component.html',
  styleUrls: ['./launch-round-of-questions.component.scss']
})
export class LaunchRoundOfQuestionsComponent implements OnInit {

  iconList = 'arrow_right';
  title = 'Send notifications';
  text = 'Do you want to send out notifications to WEEE members about this Round of Questions?';
  textYes = '<strong>Yes: </strong>Email notifications will be sent to all members for whom the Round of Questions contains Questions<br>' +
    '   - To WEEE System administrators if Round of Questions contains one or more Questions to be answered by a WEEE System administrator<br>' +
    '   - To Country Coordinators if Round of Questions contains one or more Questions to be answered by Country Coordinators';
  textNo = 'No emails are sent out.';
  textCancel = 'Launch is cancelled.';

  @Output()
  confirmWithNotificationEventEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  confirmEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor(private dialogRef: MatDialogRef<LaunchRoundOfQuestionsComponent>) { }

  ngOnInit(): void {
  }

  confirm(notification: boolean = false): void {
    if (notification) {
      this.confirmWithNotificationEventEvent.emit();
    }
    else {
      this.confirmEvent.emit();
    }
    this.closeDialog();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
